import Tippy from "@tippyjs/react";
import { setFreshmanWatched, batchSetFreshmanWatched } from "helpers/freshman";
import React, { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closeHelper,
  closeHelperList,
  selectFocusedHelper,
  selectModalActive,
} from "slices/generalSlice";
import "tippy.js/dist/tippy.css";

const HelperTip = forwardRef(
  (
    {
      code,
      children,
      component,
      placement,
      arrowWhite = false,
      style = {},
      lazy = false,
      ...rest
    },
    ref
  ) => {
    const dispatch = useDispatch();
    const alive = useSelector((state) => selectFocusedHelper(state) === code);
    const modalActive = useSelector(selectModalActive);
    const onSkipClick = (e) => {
      e.stopPropagation();
      batchSetFreshmanWatched();
      dispatch(closeHelperList());
    };
    const onClick = (e) => {
      e.stopPropagation();
      setFreshmanWatched(code);
      dispatch(closeHelper());
    };

    return (
      <Tippy
        visible={alive && !modalActive}
        animation="shift-away"
        placement={placement}
        className={`helper-tippy ${arrowWhite ? "white-arrow" : ""}`}
        popperOptions={{
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                altAxis: true,
                tether: false,
              },
            },
          ],
        }}
        content={
          <div className={`modal-box form-shadow helper-box`} style={style}>
            <div onClick={onSkipClick} className="skip-tute">
              skip
            </div>
            {/* Preventing Component Rendering until required (saves on image requests) */}
            {((lazy && alive) || !lazy) && component}
            <div className="helper-hide" onClick={onClick}>
              Next
            </div>
          </div>
        }
        appendTo={document.getElementById("space-and-video")}
        interactive
        arrow
        {...rest}
      >
        {React.cloneElement(children, ref)}
      </Tippy>
    );
  }
);

export default HelperTip;
